import React from 'react'

import { Button, type ButtonProps } from '../../../module'
import { IconAndName, type MenuActionProps } from '../Menu'
import styles from '../_menu.module.scss'

type MenuStandardRowBaseProps = Pick<
  MenuActionProps,
  | 'disabled'
  | 'confirmation'
  | 'callout'
  | 'icon'
  | 'text'
  | 'destructive'
  | 'secondaryContent'
  | 'qaTestId'
> & {
  setCurrentConfirmation: (
    confirmation: MenuActionProps['confirmation'],
  ) => void
  className: string
}

type WithLink = MenuStandardRowBaseProps & {
  link: string
  routerComponent: ButtonProps['routerComponent']
  routerProp: string
}

type WithoutLink = MenuStandardRowBaseProps & {
  link?: never
  routerComponent?: never
  routerProp?: never
}

type MenuStandardRowProps = WithLink | WithoutLink

const MenuStandardRow = ({
  className = '',
  disabled,
  confirmation,
  callout,
  icon,
  text,
  setCurrentConfirmation,
  link,
  routerComponent,
  routerProp,
  destructive,
  secondaryContent,
  qaTestId,
}: MenuStandardRowProps): React.JSX.Element => {
  const actionCallout = (
    e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>,
  ) => {
    e.stopPropagation()
    confirmation ? setCurrentConfirmation(confirmation) : callout?.()
  }

  return (
    <div className={styles.menuRow}>
      <Button
        {...(link && routerComponent
          ? {
              as: 'link',
              routerComponent,
              [routerProp]: link,
            }
          : {
              as: 'unstyled',
            })}
        className={`${className} ${styles.menuButton}`}
        disabled={disabled?.value}
        onClick={actionCallout}
        {...(disabled?.value && disabled?.tooltip
          ? { tooltip: disabled?.tooltip }
          : {})}
        qaTestId={qaTestId}
      >
        <IconAndName icon={icon} text={text} destructive={destructive} />
        {secondaryContent ? <div>{secondaryContent}</div> : null}
      </Button>
    </div>
  )
}

export default MenuStandardRow
